import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  private prefix: string = "clienthub.";

  constructor() {}

  /**
   * Stores a value in local storage with the given key.
   * @param key The key to use for storing the value.
   * @param value The value to store.
   */
  set(key: string, value: any): void {
    localStorage.setItem(this.prefix + key, JSON.stringify(value));
  }

  /**
   * Retrieves a value from local storage with the given key.
   * @param key The key to use for retrieving the value.
   * @returns The value stored under the given key, or null if no value is found.
   */
  get(key: string): any {
    const value = localStorage.getItem(this.prefix + key);
    if (value != null && value !== "undefined") {
      return JSON.parse(value);
    }
    return null;
  }

  /**
   * Removes a value from local storage with the given key.
   * @param key The key to use for removing the value.
   */
  remove(key: string): void {
    localStorage.removeItem(this.prefix + key);
  }

  /**
   * Removes all values from local storage with the current prefix.
   */
  clearAll(): void {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.prefix)) {
        localStorage.removeItem(key);
      }
    }
  }
}
